export class FabricError extends Error {
  protected constructor(
    public code: string,
    public message: string,
    public data: any
  ) {
    super(message);
    this.name = `FabricError`;
  }
  public toJSON = function () {
    return {
      // Fabric
      name: this.name,
      code: this.code,
      data: this.data,
      message: this.message,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
    };
  };
}
